<template>
  <div class="px-4">
    <div class="flex h-16 justify-between">
      <div class="flex w-full items-center justify-between">
        <div class="flex shrink-0 items-center space-x-6">
          <a href="https://pastaevangelists.com/" aria-label="Go to homepage">
            <ThePastaLogo class="h-auto w-[100px] cursor-pointer py-4 text-terracota-dark" />
          </a>
        </div>
        <div class="hidden space-x-1 lg:flex">
          <CardIcon class="w-10" brand="mastercard" />
          <CardIcon class="w-10" brand="visa" />
          <CardIcon class="w-10" brand="amex" />
          <template v-if="!hideThirdPartyPayments">
            <CardIcon class="w-10" brand="google_pay" />
            <CardIcon class="w-10" brand="apple_pay" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import ThePastaLogo from '@/components/ThePastaLogo.vue';

  interface Props {
    hideThirdPartyPayments?: boolean;
  }

  defineProps<Props>();
</script>
